import common from "utils/common";

export default { common };
